import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Enregistrer les éléments nécessaires
ChartJS.register(ArcElement, Tooltip, Legend);

interface ComplaintsChartProps {
  title: string;
  databyParent: {
    labels: string[];
    values: number[];  
  } | undefined;
  count?: number;
}

const ComplaintsChart: React.FC<ComplaintsChartProps> = ({
  title,
  databyParent,
  count
}) => {

  const labelMap : { [key: string]: string }= {
    PENDING: "En attente",
    IN_PROGRESS: "En cours",
    ESCALATED: "Escaladé",
    RESOLVED_POSITIVE: "Résolues positives",
    RESOLVED_NEGATIVE: "Résolues négatives",
    ARCHIVED  : "Archivé",
    CURRENTLY_PROCESSED : "En cours de traitement",
    SAVED : "Enregistrés",
    IN_PROGRESS_VALIDATION : "En cours de validation",
    AWAITING_RESPONSE : "En attente de réponse",


  };
  
  const colorMap : { [key: string]: string } = {
    ESCALATED: "#edff21",
    PENDING: "#2516f6",
    RESOLVED_POSITIVE: "#086D33",
    RESOLVED_NEGATIVE: "#D32F2F",
    IN_PROGRESS: "#FFA726",
    ARCHIVED: "#9E9E9E",
    CURRENTLY_PROCESSED: "#7CB342",
    SAVED: "#8D6E63",
    IN_PROGRESS_VALIDATION: "#FFD54F",
    AWAITING_RESPONSE: "#42A5F5",
  };
  
  const labels = databyParent?.labels.map(label => labelMap[label] || "");
  const backgroundColor = databyParent?.labels.map(label => colorMap[label] || "");
  
  const data = {
    labels,
    datasets: [
      {
        data: databyParent?.values,
        backgroundColor,
        borderWidth: 4,
        borderRadius: 10,
      },
    ],
  };

  
  const result = databyParent?.labels.map((label, index) => ({
    label: label,
    value: databyParent?.values[index],
  }));

const dataView = () => {
  return result?.map((item, index) => {
    if (item.label === "ESCALATED") {
      return (
        <div key={index} className="flex items-center gap-2">
          <span className="w-5 h-5 rounded-full bg-[#edff21]"></span>
          <span className="text-sm text-gray-600">Escaladé</span>
        </div>
      );
    } else if (item.label === "PENDING") {
      return (
        <div key={index} className="flex items-center gap-2">
          <span className="w-5 h-5 rounded-full bg-[#2516f6]"></span>
          <span className="text-sm text-gray-600">En attente</span>
        </div>
      );
    } else if(item.label === "IN_PROGRESS") {
      return (
        <div key={index} className="flex items-center gap-2">
          <span className="w-5 h-5 rounded-full bg-[#FFA726]"></span>
          <span className="text-sm text-gray-600">En cours</span>
        </div>
      );
    }else if(item.label === "ARCHIVED") {
      return (
        <div key={index} className="flex items-center gap-2">
          <span className="w-5 h-5 rounded-full bg-[#9E9E9E]"></span>b
          <span className="text-sm text-gray-600">Archivé</span>
        </div>
      );
    }else if(item.label === "RESOLVED_POSITIVE") {
      return (
        <div key={index} className="flex items-center gap-2">
          <span className="w-5 h-5 rounded-full bg-[#086D33]"></span>
          <span className="text-sm text-gray-600">Résolues positives</span>
        </div>
      );
    }
    else if(item.label === "CURRENTLY_PROCESSED") {
      return (
        <div key={index} className="flex items-center gap-2">
          <span className="w-5 h-5 rounded-full bg-[#7CB342]"></span>
          <span className="text-sm text-gray-600">En cours de traitement</span>
        </div>
      );
    }else if(item.label === "SAVED") {
      return (
        <div key={index} className="flex items-center gap-2">
          <span className="w-5 h-5 rounded-full bg-[#8D6E63]"></span>
          <span className="text-sm text-gray-600">Enregistrés</span>
        </div>
      );
    }else if(item.label === "IN_PROGRESS_VALIDATION") {
      return (
        <div key={index} className="flex items-center gap-2">
          <span className="w-5 h-5 rounded-full bg-[#FFD54F]"></span>
          <span className="text-sm text-gray-600">En cours de validation</span>
        </div>
      );
    }else if(item.label === "AWAITING_RESPONSE") {
      return (
        <div key={index} className="flex items-center gap-2">
          <span className="w-5 h-5 rounded-full bg-[#42A5F5]"></span>
          <span className="text-sm text-gray-600">En attente de réponse</span>
        </div>
      );
    }else {
      return (
        <div key={index} className="flex items-center gap-2">
          <span className="w-5 h-5 rounded-full bg-[#D32F2F]"></span>
          <span className="text-sm text-gray-600">Résolues négatives</span>
        </div>
      );
    }
  });
};

  const options = {
    cutout: "65%",
    responsive:true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return (
    <div className="bg-white rounded-lg shadow-md w-full h-[300px] lg:h-[400px] mb-10">
      <div className="p-4 text-md font-semibold text-gray-600 border-b border-gray-300 pb-2">
        {title}
      </div>
      <div className="flex items-center bg-white">
        <div className="w-[65%] h-[250px] lg:h-[300px] lg:w-2/3 relative flex items-center justify-center my-4">
          <Doughnut data={data} options={options} />
          <div className="absolute flex flex-col items-center">
            <p className="text-3xl font-bold text-gray-800">{count}</p>
            <p className="text-sm text-gray-500">Plaintes</p>
          </div>
        </div>
        <div className="w-[35%] lg:w-1/3 flex flex-col gap-4 legende ml-10">
          {dataView()}
        </div>
      </div>
    </div>
  );
};

export default ComplaintsChart;
